export const trueFriendsForm = (count: number) => trueWordForm(count, ['друг', 'друга', 'друзей']);
export const trueInvitedFriendsForm = (count: number) => trueWordForm(count, ['приглашенный друг', 'приглашенных друга', 'приглашенных друзей']);
export const truePlayersForm = (count: number) => trueWordForm(count, ['игрок', 'игрока', 'игроков']);
export const truePrizesForm = (count: number) => trueWordForm(count, ['приз', 'приза', 'призов']);
export const trueDrawsForm = (count: number) => trueWordForm(count, ['розыгрыш', 'розыгрыша', 'розыгрышей']);
export const trueMembersForm = (count: number) => trueWordForm(count, ['участник', 'участника', 'участников']);
export const trueCandidateForm = (count: number) => trueWordForm(count, ['претендент', 'претендента', 'претендентов']);
export const trueCandidateForm_2 = (count: number) => trueWordForm(count, ['претендента', 'претендента', 'претендентов']);
export const trueWinnerForm_2 = (count: number) => trueWordForm(count, ['победителя', 'победителей', 'победителей']);
export const trueTicketForm = (count: number) => trueWordForm(count, ['билет', 'билета', 'билетов']);
export const trueFragmentsForm = (count: number) => trueWordForm(count, ['фрагмент', 'фрагмента', 'фрагментов']);
export const trueAchievementsForm = (count: number) => trueWordForm(count, ['достижение', 'достижения', 'достижений']);
export const trueRatingsForm = (count: number) => trueWordForm(count, ['рейтинг', 'рейтинга', 'рейтингов']);
export const trueCollectionsForm = (count: number) => trueWordForm(count, ['коллекция', 'коллекции', 'коллекций']);
export const trueBoostsForm = (count: number) => trueWordForm(count, ['усиление', 'усиления', 'усилений']);
export const trueLimitsForm = (count: number) => trueWordForm(count, ['ограничение', 'ограничения', 'ограничения']);

export const trueDaysForm = (count: number) => trueWordForm(count, ['день', 'дня', 'дней']);
export const trueMinutesForm2 = (count: number) => trueWordForm(count, ['минута', 'минуты', 'минут']);
export const trueSecondsForm2 = (count: number) => trueWordForm(count, ['секунда', 'секунды', 'секунд']);
export const trueHoursForm = (count: number) => trueWordForm(count, ['час', 'часа', 'часов']);

export const trueWordForm = (count: number, forms: [string, string, string]): string => {
    return _trueWordform(count, forms[0], forms[1], forms[2]);
}

const _trueWordform = (num: number, form_for_1: string, form_for_2: string, form_for_5: string): string => {
    num = Math.abs(num) % 100;
    var num_10: number = num % 10;
    
    if (num > 10 && num < 20)
        return form_for_5;
    if (num_10 > 1 && num_10 < 5)
        return form_for_2;
    if (num_10 === 1)
        return form_for_1;
        
    return form_for_5;
}
